import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { Control, Controller } from 'react-hook-form';
import { DiamDetailsFields, DiamDetailsTextField } from '../DiamDetailsFields';
import { SectionTitle } from '../IdentityDetails/styles';
import { FieldStack } from './styles';
import { RoleDetailsFormValues, RoleSelectOption } from './types';

interface RoleDetailsGeneralSectionProps {
  isEditing: boolean;
  control: Control<RoleDetailsFormValues>;
  name: string;
  teamName: string;
  description: string;
  teamOptions: RoleSelectOption[];
}

export function RoleDetailsGeneralSection({
  isEditing,
  control,
  name,
  teamName,
  description,
  teamOptions,
}: RoleDetailsGeneralSectionProps) {
  return (
    <>
      <SectionTitle color="textPrimary" variant="h6">
        General
      </SectionTitle>
      {isEditing ? (
        <FieldStack>
          <Controller
            name="name"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                variant="outlined"
                label="Name"
                required
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={Boolean(error)}
                helperText={error?.message}
              />
            )}
          />
          <Controller
            name="teamId"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                select
                variant="outlined"
                label="Team"
                required
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={Boolean(error)}
                helperText={error?.message}
              >
                {teamOptions.map(teamOption => (
                  <MenuItem key={teamOption.value} value={teamOption.value}>
                    {teamOption.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
          <Controller
            name="description"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                variant="outlined"
                label="Description"
                required
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={Boolean(error)}
                helperText={error?.message}
              />
            )}
          />
        </FieldStack>
      ) : (
        <DiamDetailsFields>
          <DiamDetailsTextField title="Name" value={name} />
          <DiamDetailsTextField title="Team" value={teamName} />
          <DiamDetailsTextField title="Description" value={description} />
        </DiamDetailsFields>
      )}
    </>
  );
}
